import React from 'react'

import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react'
import { cilGlobeAlt } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { availableLanguages } from '../../utils/translate'
import { loadAxiosConfig, ThemeAxios } from '../../utils/axios'
import { useToasts } from 'react-toast-notifications'
import { selectJwt } from '../../redux/features/jwt/jwtSlice'
import {
  selectCurrentUser,
  setValue as updateCurrentUser,
} from '../../redux/features/currentUser/currentUserSlice'
import { selectActiveBusinessEntity } from '../../redux/features/activeBusinessEntity/activeBusinessEntitySlice'

const LanguageDropdown = () => {
  const currentUser = useAppSelector(selectCurrentUser)
  const { addToast } = useToasts()
  const themeAxios = new ThemeAxios(
    addToast,
    false,
    false,
    currentUser?.active_language || null,
  ).getAxios()
  const activeBusinessEntity = useAppSelector(selectActiveBusinessEntity)
  const jwt = useAppSelector(selectJwt)
  const dispatch = useAppDispatch()

  const updateUserLanguagePreference = (language) => {
    const endpoint = '/users/' + currentUser.id
    themeAxios
      .put(
        endpoint,
        { active_language: language },
        loadAxiosConfig(jwt, activeBusinessEntity?.id || 0),
      )
      .then((responseData) => {
        const newSetLanguage = responseData.data.attributes.active_language
        dispatch(updateCurrentUser({ ...currentUser, active_language: newSetLanguage }))
      })
  }

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle>
        <CIcon icon={cilGlobeAlt} size="lg" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0">
        {availableLanguages.map((lang) => (
          <CDropdownItem
            key={lang.language}
            onClick={() => {
              updateUserLanguagePreference(lang.language)
            }}
          >
            {lang.icon ? lang.icon : null}
            {lang.name}
          </CDropdownItem>
        ))}
      </CDropdownMenu>
    </CDropdown>
  )
}

export default LanguageDropdown
